export enum CustomerType {
    Customer = 1,
    Guest = 2
}